import { ServiceTimeKindType } from '@ancon/wildcat-types'

export const AsSoonAsPossibleServiceTime = {
  kind: ServiceTimeKindType.AsSoonAsPossible,
  time: '',
}

/** The open cart, which "Show cart" in the cart rail opens and focuses */
export const CartDrawerId = 'cart-drawer'

/** Focused again when the cart is closed or collapsed */
export const CartRailShowCartButtonId = 'cart-rail-show-cart'
